import { Injectable, TemplateRef } from '@angular/core';
import { Params } from '@angular/router';
import { Crumb } from '@fleet-beat/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface CrumbItemConfig {
  path?: string;
  label?: string;
  queryParams?: Params | null;
  template?: TemplateRef<unknown>;
}

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private breadcrumbs$: BehaviorSubject<Crumb[]> = new BehaviorSubject([]);
  private templateRef$: BehaviorSubject<TemplateRef<unknown> | null> = new BehaviorSubject(null);

  tplRef(): Observable<TemplateRef<unknown>> {
    return this.templateRef$.asObservable();
  }
  crumbs(): Observable<Crumb[]> {
    return this.breadcrumbs$.asObservable();
  }

  setCrumbs(config: CrumbItemConfig[]): void {
    this.buildBreadcrumbs(config);
  }

  setTemplate(tpl: TemplateRef<unknown>): void {
    this.templateRef$.next(tpl);
  }

  // NOTE Breadcrumbs Utils:

  private buildBreadcrumbs(crumbs: CrumbItemConfig[]): void {
    if (!crumbs.length) {
      this.breadcrumbs$.next([]);
      return;
    }
    const crumbsFormatted: Crumb[] = crumbs.map((c: CrumbItemConfig) => {
      return {
        ...c,
        type: c.template ? 'template' : 'default',
      };
    });
    this.breadcrumbs$.next(crumbsFormatted);
  }
}
